import AttributesContainer from "./AttributesContainer";
export default AttributesContainer;
